import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {TicketsService} from "@app/services/tickets/tickets.service";
import {LoginService} from "@app/login/login.service";
import {PortalUser} from "@app/model/portal-user.model";
import {CreditUnionService} from "@app/services/credit-union/credit-union.service";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ConfirmDialogComponent} from "@app/pages/tickets/new-ticket/confirm-dialog/confirm-dialog.component";
import {AlertsService} from "@app/services/misc-services/alerts.service";
import {GetTicketModel} from "@app/model/ticket.model";
import {BehaviorSubject} from "rxjs";
import {cloneDeep} from "lodash"
import {GlobalSpinnerService} from "@app/services/misc-services/global-spinner.service";

@Component({
  selector: 'flex-ticket-view',
  templateUrl: './ticket-view.component.html',
  styleUrls: ['./ticket-view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TicketViewComponent implements OnInit {
  activeUser: PortalUser;
  allPortalUsers: BehaviorSubject<PortalUser[]> = new BehaviorSubject<PortalUser[]>([]);
  newNote: string = ''
  today: Date = new Date();
  dialogRef: MatDialogRef<ConfirmDialogComponent>;
  closeRequest: boolean = false;
  reasonToClose: string = '';
  ticket: GetTicketModel;

  // None of these are used because points aren't working currently
  // availablePoints: number;
  // addedPoints: number = 0;
  // totalCommunityPoints: number = 0;

  constructor(public ticketService: TicketsService,
              public userService: LoginService,
              public creditUnionService: CreditUnionService,
              public dialog: MatDialog,
              public alert: AlertsService,
              public spinner :GlobalSpinnerService,
              public cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.userService.getActiveUserSubject().subscribe((user) => {
      this.activeUser = user;
    })
    this.allPortalUsers = this.creditUnionService.getAllPortalUsers();
    if (!this.ticketService.selectedTicket.value) {
      this.ticketService.backToTicketList();
    } else {
      this.ticket = cloneDeep(this.ticketService.selectedTicket.value);
    }
  }

  saveNoteToTicket() {
    this.spinner.addEvent('saving');
    this.ticketService.saveTicketNote(
        this.ticketService.createNoteDTO(
            this.newNote,
            this.activeUser,
            this.ticketService.selectedTicket.value.ticket.ticketNumber))
        .subscribe(() => {
      this.ticketService.getTicket(this.ticketService.selectedTicket.value.ticket.ticketNumber).subscribe((ticket: GetTicketModel) => {
        this.spinner.removeEvent('saving');
        this.newNote = '';
        this.ticketService.selectedTicket.next(ticket);
        this.ticket = cloneDeep(ticket);
        this.cdr.detectChanges();
      });
    })
  }

  saveTicket() {
    this.spinner.addEvent('update');
    this.ticketService.updateTicket(this.ticket.ticket, this.activeUser).subscribe(() => {
      this.ticketService.selectedTicket.next(cloneDeep(this.ticket));
      this.spinner.removeEvent('update')
      if (this.newNote !== '') {
        this.saveNoteToTicket();
      }
      if (this.ticketService.attachmentsToUpload.length > 0) {
        this.ticketService.uploadAttachmentList(this.ticket.ticket.ticketNumber);
      }
    });
  }

  selectFiles() {
    const select = document.createElement('input');
    select.type = 'file';
    select.accept = '.png, .jpg, .jpeg, .pdf, .txt'
    select.multiple = true;
    select.addEventListener('change', () => {this.uploadAttachments(select.files)});
    select.click();
  }

  uploadAttachments(event) {
    this.ticketService.fileSelected(event);
    setTimeout(() => this.cdr.detectChanges(), 250)
  }

  removeAttachmentFromList(index: number) {
    this.ticketService.attachmentsToUpload.splice(index, 1);
    setTimeout(() => this.cdr.detectChanges(), 250)
  }

  closeRequestDialog() {
    this.dialogRef = this.dialog.open(ConfirmDialogComponent, {maxWidth: '800px', data: {closed: false, reason: ''}})
    this.dialogRef.afterClosed().subscribe((res: {confirm: boolean, reason: string}) => {
      if (res.confirm === true) {
        this.ticket.ticket.status = 'C';
        this.ticket.ticket.percentComplete = 100;
        this.ticketService.updateTicket(this.ticket.ticket, this.activeUser).subscribe(() => {
          this.ticketService.refreshTicketsAndGoBack();
        });
      }
    })
  }

  requestToOpenDialog() {
    this.dialogRef = this.dialog.open(ConfirmDialogComponent, {maxWidth: '800px', data: {closed: true, reason: ''}})
    this.dialogRef.afterClosed().subscribe((res: {confirm: boolean, reason: string}) => {
      this.spinner.addEvent('opening');
      if (res.confirm === true) {
        this.ticket.ticket.status = 'O';
        this.ticket.ticket.percentComplete = 95;
        this.ticketService.updateTicket(this.ticket.ticket, this.activeUser).subscribe(() => {
          this.spinner.removeEvent('opening')
          this.ticketService.getTicket(this.ticket.ticket.ticketNumber).subscribe((ticket: GetTicketModel) => {
            this.ticketService.selectedTicket.next(ticket);
            this.ticket = cloneDeep(this.ticketService.selectedTicket.value)
          })
        });
      }
    })
  }

  // TODO: THIS IS COMMENTED OUT BECAUSE THERE IS NO WAY TO GET THE CURRENT POINTS FROM THE TICKET OBJECT
  // getPoints() {
  //   this.creditUnionService.getFlexPoints(this.activeUser.cuid).subscribe((response: {class: string, cuid: string, id: number, points: number, version: number}) => {
  //     this.availablePoints = 100 - response.points;
  //   })
  // }
  //
  // increasePoints() {
  //   if (this.availablePoints > 0) {
  //     this.totalCommunityPoints = this.totalCommunityPoints + 5;
  //     this.addedPoints = this.addedPoints + 5;
  //     this.availablePoints = this.availablePoints - 5;
  //   }
  // }
  //
  // decreasePoints() {
  //   if (this.totalCommunityPoints === 0) {
  //     this.totalCommunityPoints = 0;
  //   } else {
  //     this.totalCommunityPoints = this.totalCommunityPoints - 5;
  //     this.addedPoints = this.addedPoints - 5;
  //     this.availablePoints = this.availablePoints + 5;
  //   }
  // }

}